export const productModalComponent = {
  key: 'productModalComponent',
  name: 'Product Modal Component',
  siteIdentifier: 'global',

  closeButton: 'Close',
};
